import React from "react";

import ShopHeader from "../components/ShopHeader";
import Failed from "../../loading/pages/Failed";
import { PALETTE } from "../../common/ThemeConstants";
import IconWorkout from "../../common/images/iconWorkoutActive.png";

import { useState, useEffect } from "react";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import { useAuth } from "../../auth/hook";
import NavLinkButton from "../../common/components/NavLinkButton";
import { Container, Row } from "react-bootstrap";
import CardPurchase from "../components/CardPurchase";

export default function PurchasedWorkouts() {
  const auth = useAuth();
  const [workouts, setWorkouts] = useState([]);

  useEffect(() => {
    if (auth.user.workouts) {
      setWorkouts(auth.user.workouts);
    }
  }, [setWorkouts, auth.user.workouts]);

  return (
    <>
      <ShopHeader />
      <ContainerResponsive>
        {workouts.length > 0 && (
          <Container className="mt-1">
            {workouts.map((workout, index) => (
              <Row key={index} className="py-2 px-1 w-100 m-auto">
                <CardPurchase
                  img={IconWorkout}
                  title={workout.name}
                  startDate={workout.start_at}
                  expireDate={workout.expire_at}
                />
              </Row>
            ))}
          </Container>
        )}
        {workouts.length == 0 && (
          <>
            <Failed
              separatorText=""
              mainDescription="Nessun allenamento acquistato"
              color={PALETTE.MAINCOLOR}
              children={
                <NavLinkButton
                  text={
                    <>
                      <img src={IconWorkout} style={{ width: 30 }} />
                      <p style={{ marginBottom: 0, fontSize: 15 }}>
                        <span style={{ fontSize: 14, color: PALETTE.DARKGRAY }}>
                          {"Inizia ora"}
                        </span>
                      </p>
                      <span style={{ fontSize: 12, color: PALETTE.GRAY }}>
                        vai alla sezione allenamenti
                      </span>
                    </>
                  }
                  to={"/account/Workouts"}
                  backgroundColor={PALETTE.WHITE}
                  color={PALETTE.GRAY}
                  backgroundColorHover={PALETTE.GRADIENTLIGHT}
                  colorHover={PALETTE.GRAY}
                  shadow={true}
                />
              }
            />
          </>
        )}
      </ContainerResponsive>
    </>
  );
}
